import React from 'react'
import './join.css'

const Join = () => {
  return (
    <div className='join'>
      <div>
      <p className='join_first1 gradient__text'>Empowering Blockchain Innovation</p>
      <h1>
      Join The Origin Guild Community
      </h1>
     </div>
    <div className='join-p'>
       <p>
       Origin Guild Bhopal is a vibrant Web3 and blockchain community driving innovation, collaboration and growth. Join us to connect with passionate individuals, share knowledge and shape the future of decentralized technology.
       </p>
   </div>
   <button className=' mx-auto'><a href="https://chat.whatsapp.com/HsDiELGi2OmL12NzzhnE2D">Join Now</a></button>

    </div>
   
    
  )
}

export default Join
